import { render, staticRenderFns } from "./Calc1.vue?vue&type=template&id=5d0c099a&scoped=true&"
import script from "./Calc1.ts?vue&type=script&lang=ts&"
export * from "./Calc1.ts?vue&type=script&lang=ts&"
import style0 from "./Calc1.css?vue&type=style&index=0&id=5d0c099a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0c099a",
  null
  
)

export default component.exports